import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const CMSDrivenPageTemplateStyles = makeStyles((theme) => ({
  contentWrapper: {
    [theme.breakpoints.down("md")]: {
      width: "768px"
    },
    [theme.breakpoints.between("sm", 833)]: {
      width: "640px"
    },
    [theme.breakpoints.up(833)]: {
      width: "1280px"
    },
    color: COLORS.DARK_GRAY_2,
    fontFamily: "Inter, sans-serif",
    "& h1": {
      fontFamily: "Merriweather, serif"
    },
    "& .content-title": {
      marginBottom: 15,
      fontWeight: 600,
      fontSize: "20px",
      lineHeight: "28px",
      paddingRight: "40px",
      "& a": {
        textDecoration: "none",
        cursor: "pointer",
        color: COLORS.ACCENT2
      }
    },
    "& .content-summary": {
      paddingRight: "40px",
      fontSize: "14px",
      fontWeight: 400,
      color: COLORS.DARK_GRAY,
      marginBottom: "35px"
    },
    "& .content-hr": {
      marginRight: "40px",
      backgroundColor: COLORS.GRAY,
      marginBottom: "35px",
      border: "none",
      height: "1px"
    }
  }
}));

export default CMSDrivenPageTemplateStyles;
